import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Cities } from '@/models/cities';
import filterModel from '@/store/cities/filterModel';
import CitiesFilter from '@/store/cities/filterEntity';
import { Filter } from '@/types/filter/filter';

export const MODULE_NAME = Cities.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class CitiesModule extends PageBaseModule {
    filter: Filter;

    constructor(module: CitiesModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Cities.listTitle);
        page.setTitleAdd(Cities.createTitle);
        page.values.actionPagination = 'cities/updatePage';
        page.values.actionPageAmountItems = 'cities/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Cities.moduleName}_edit`;
        this.pageSettings.routeParam = `${Cities.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(CitiesFilter);
        this.filter.setFilterName('citiesFilter');
        this.filter.setTemplateClassName('template-lg directory-filters');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                Cities.moduleName,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.context.dispatch('setList', result.table);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });

                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }
}

export default getModule(CitiesModule);
